import { Outlet } from "react-router-dom"



const Employees = ( ) => {

    return <Outlet />
}

export default Employees;